import { useIntl } from "@amazeelabs/react-intl";
import React from "react";
export function SkipLinks() {
    var intl = useIntl();
    return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement("a", {
        href: "#main-content",
        className: "skip-link"
    }, intl.formatMessage({
        defaultMessage: "Skip to content",
        id: "ZKtRoA"
    })), /*#__PURE__*/ React.createElement("a", {
        href: "#footer",
        className: "skip-link"
    }, intl.formatMessage({
        defaultMessage: "Skip to footer",
        id: "oSFN9i"
    })));
}
